const obj = {}

obj.USER_GROUPS = {
  superadmin: 'superadmin',
  owneradmin: 'owneradmin',
  admin: 'admin',
  subadmin: 'subadmin',
  user: 'user',
  databasehelper: 'databasehelper',
  custom: 'custom',
}

const custom = {
  TAKE_RATE_REVBOOST_OFFERS: [
    'extendteccrevboostspecial',
    'ionpurerevboostspecial',
    'propowersaverevboostspecial',
  ],
};

obj.FEATURES = {
  // profile
  profile: 'profile',

  // features
  predefined_filters: 'predefined_filters',

  // reports
  consumption_report: 'consumption_report',
  profit_report: 'profit_report',
  products_list: 'products_list',
  take_rate_report: 'take_rate_report',
  revboost_report: 'revboost_report',
  vip_report: 'vip_report',

  // shipping reports
  firstmile_cost_analysis: 'firstmile_cost_analysis',
  ship_cost_by_offer: 'ship_cost_by_offer',
  ship_cost_by_pickup_date: 'ship_cost_by_pickup_date',
  campaign_fulfillment: 'campaign_fulfillment',

  // utils
  upload_firstmile: 'upload_firstmile',

  // API URLs and detailed permissions
  CONSUMPTION_REPORT: {
    api_url: '/reports/salesperformance/consumption',
  },

  PROFIT_REPORT: {
    RESTRICT_FIELDS: {
      max: [
        'revenue',
        'click_bump_count', 'click_bump_rate',
        'cashflow', 'net_profit', 'net_profit_per_order'
      ],
      jon: [
        'revenue',
        'click_bump_count', 'click_bump_rate',
        'cashflow', 'net_profit', 'net_profit_per_order'
      ],
      dan: [
        'total_orders', 'revenue', 'revenue_per_order',        
        'click_bump_count', 'click_bump_rate',
        'total_cpa_cost',        
        'cogs', 'processing_cost', 'reserve_cost', 'processing_plus_reserves', 
        'total_shipping_cost', 'total_handling_cost', 'cost_of_cs', 'total_transactions_cost',
        'number_of_voids', 'void_dollar_amount', 
        'number_of_refunds', 'refund_dollar_amount', 
        'chargeback_count', 'chargeback_dollar_amount',
        'cashflow', 'net_profit', 'net_profit_per_fe', 'net_profit_per_order', 'net_profit_margin'
      ],
      alex: [
        'net_profit'
      ],
      goran: [
        'net_profit'
      ],
      tiff: [
        'net_profit'
      ],
    },
    RESTRICT_SQL: {
      DEFAULT: "and 1 = 0",
      max: "",
      jon: "",
      dan: "",
      davidteo: "and t.affid = '1774' and c.is_scrub = 'no'",
      raj: "and t.affid = '1774' and c.is_scrub = 'no'",
      christian: "and t.affid = '1774' and c.is_scrub = 'no'",
    }
  },

  TAKE_RATE_REPORT: {
    api_url: '/reports/takerate/:offer',
    ALLOW_OFFERS: {
      revboost: custom.TAKE_RATE_REVBOOST_OFFERS,
      // all offers
      davidteo: ['*'],
      raj: ['*'],
      christian: ['*'],
      jendalumpines: ['*'], 
      jobany: ['*'], 
      jon: ['*'],
    },
    RESTRICT_SQL: {
      DEFAULT: "and 1 = 0",
      revboost: "",
      davidteo: "",
      raj: "",
      christian: "",
      jendalumpines: "",
      jobany: "",
      jon: "",
    }
  },

  REVBOOST_REPORT: {
    api_url: '/reports/profitabilitydiagnosis/revboost'
  },

  VIP_REPORT: {
    api_url: '/reports/vip/'
  },

  // shipping reports

  FIRSTMILE_COST_ANALYSIS: {
    api_url: '/reports/firstmilecostanalysis/'
  },

  SHIP_COST_BY_OFFER: {
    api_url: '/reports/shippingreports/shipcostbyoffer'
  },

  SHIP_COST_BY_PICKUP_DATE: {
    api_url: '/reports/shippingreports/shipcostbypickupdate'
  },
  
  // utils

  UPLOAD_FIRSTMILE: {
    api_url: '/firstmile'
  }
}

obj.checkAccess = (feature, userData = obj.getUserData()) => {
  if (!userData) {
    return false;
  }

  const allow_groups = [obj.USER_GROUPS.superadmin];
  const allow_users = [];

  // profile
  if (feature === obj.FEATURES.profile) {
    allow_groups.push(obj.USER_GROUPS.owneradmin,
                      obj.USER_GROUPS.admin,
                      obj.USER_GROUPS.subadmin,
                      obj.USER_GROUPS.user);
  }
  // features
  else if (feature === obj.FEATURES.predefined_filters) {
    allow_groups.push(obj.USER_GROUPS.owneradmin,
                      obj.USER_GROUPS.admin,
                      obj.USER_GROUPS.subadmin,
                      obj.USER_GROUPS.user);
  }
  // reports
  else if (feature === obj.FEATURES.consumption_report) {
    allow_groups.push(obj.USER_GROUPS.owneradmin);
    allow_groups.push(obj.USER_GROUPS.admin);
    allow_groups.push(obj.USER_GROUPS.subadmin);
    allow_groups.push(obj.USER_GROUPS.user);
    allow_users.push('jendalumpines');    
  } else if (feature === obj.FEATURES.profit_report) {
    allow_groups.push(obj.USER_GROUPS.owneradmin);
    allow_users.push('max');
    allow_users.push('jon');
    allow_users.push('dan');
    allow_users.push('davidteo');
    allow_users.push('raj');
    allow_users.push('christian');
  } else if (feature === obj.FEATURES.products_list) {
    allow_groups.push(obj.USER_GROUPS.owneradmin);
    allow_groups.push(obj.USER_GROUPS.admin);
  } else if (feature === obj.FEATURES.take_rate_report) {
    allow_groups.push(obj.USER_GROUPS.owneradmin);
    allow_groups.push(obj.USER_GROUPS.admin);
    allow_groups.push(obj.USER_GROUPS.subadmin);
    allow_groups.push(obj.USER_GROUPS.user);
    allow_users.push('revboost');
    allow_users.push('davidteo');
    allow_users.push('raj');
    allow_users.push('christian');
    allow_users.push('jendalumpines');    
    allow_users.push('jobany');    
    allow_users.push('jon');    
  } else if (feature === obj.FEATURES.revboost_report) {
    allow_groups.push(obj.USER_GROUPS.owneradmin);
    allow_users.push('revboost');
    allow_users.push('davidteo');
    allow_users.push('raj');
    allow_users.push('christian');
    allow_users.push('dan');
    allow_users.push('max');
    allow_users.push('jon');    
  } else if (feature === obj.FEATURES.vip_report) {
    allow_groups.push(obj.USER_GROUPS.owneradmin);
    allow_users.push('max');
    allow_users.push('jon');    
  // shipping reports
  } else if (feature === obj.FEATURES.firstmile_cost_analysis
          || feature === obj.FEATURES.ship_cost_by_offer
          || feature === obj.FEATURES.ship_cost_by_pickup_date
    ) {
    allow_groups.push(obj.USER_GROUPS.owneradmin);
    allow_groups.push(obj.USER_GROUPS.admin);
    allow_groups.push(obj.USER_GROUPS.subadmin);
    allow_groups.push(obj.USER_GROUPS.user);
    allow_users.push('jendalumpines');    
  // campaign fulfillment
  } else if (feature === obj.FEATURES.campaign_fulfillment) {
    allow_groups.push(obj.USER_GROUPS.owneradmin);
    allow_users.push('max');
    allow_users.push('dan');
  // utils
  } else if (feature === obj.FEATURES.upload_firstmile) {
    allow_groups.push(obj.USER_GROUPS.owneradmin);
    allow_groups.push(obj.USER_GROUPS.admin);
    allow_groups.push(obj.USER_GROUPS.subadmin);
    allow_groups.push(obj.USER_GROUPS.databasehelper);
    allow_users.push('jendalumpines');    
  }

  return allow_groups.includes(userData.type) || allow_users.includes(userData.username);
}

obj.checkProfitReportColumnAccess = (column, userData = obj.getUserData()) => {
  if (!userData || !userData.username) {
    return false;
  }

  const restrict_columns = obj.FEATURES.PROFIT_REPORT.RESTRICT_FIELDS[userData.username];

  return !restrict_columns || !column || !restrict_columns.includes(column.toLowerCase());
}

obj.checkTakeRateOfferAccess = (offer, userData = obj.getUserData()) => {
  if (!userData || !userData.username) {
    return false;
  }

  const allow_offers = obj.FEATURES.TAKE_RATE_REPORT.ALLOW_OFFERS[userData.username];

  return !allow_offers || !offer || allow_offers.includes(offer.toLowerCase()) ||
    (allow_offers.length && allow_offers[0] === '*');
}

obj.getUserData = () => {
  const userData = JSON.parse(localStorage.getItem('userdata'));

  // override username
  if (userData.type === obj.USER_GROUPS.superadmin &&
      userData.username &&
      window && window.location && window.location.pathname &&
      window.location.pathname.includes('asuser/')) {
    const parsing = window.location.pathname.split('asuser/')[1];
    userData.username = (parsing ? parsing.split('/')[0] : '');
  }

  return userData;
}

module.exports = obj;